import React from 'react';
import { PhoneIcon, MailIcon, MapPinIcon, PrinterIcon, WrenchIcon } from 'lucide-react';
import { site } from '../data/site';
export function ContactDetails({
  dark = false
}: {
  dark?: boolean;
}) {
  const base = dark ? 'border-white/10 bg-ink-800 text-steel-300' : 'border-steel-200 bg-white text-steel-500';
  const heading = dark ? 'text-white' : 'text-ink';
  return <div className={`rounded-sm border shadow-card ${base}`} data-id="element-35" data-mp="h81dra3pz73z">
      <div className="hatch h-1.5 w-full" aria-hidden="true" data-id="element-36" data-mp="h68920co2wym" />
      <div className="space-y-6 p-6 sm:p-8" data-id="element-37" data-mp="d7962lahxa9t">
        <div data-id="element-38" data-mp="d4d9p1eaqtnh">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-safety" data-id="element-39" data-mp="d4mwkg41okoy">
            Free Estimates
          </p>
          <a href={site.estimatePhone.href} className={`mt-1 block font-display text-3xl font-bold tracking-tight ${heading} hover:text-safety`} data-id="element-40" data-mp="ly9htcamm5jw">
            {site.estimatePhone.display}
          </a>
          <p className="mt-1 text-sm" data-id="element-41" data-mp="vyihj03tu941">
            Also written as {site.estimatePhone.alt}
          </p>
        </div>

        <div className="rounded-sm border border-safety/40 bg-safety-100 p-4" data-id="element-42" data-mp="d65xvabbhuv2">
          <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-safety-600" data-id="element-43" data-mp="i3plh0twnjzo">
            <WrenchIcon className="h-4 w-4" aria-hidden="true" data-id="element-44" data-mp="m3g94vo4xjzz" />
            Plumbing Line
          </p>
          <a href={site.plumbingPhone.href} className="mt-1 block font-display text-2xl font-bold tracking-tight text-ink hover:text-safety-600" data-id="element-45" data-mp="r1rht32p1ogm">
            {site.plumbingPhone.display}
          </a>
          <p className="mt-1 text-sm text-ink-600" data-id="element-46" data-mp="15t0c3phjjy03">
            Leaky faucets, running toilet or frozen pipes — including emergency
            plumbing service.
          </p>
        </div>

        <ul className="space-y-4 text-sm" data-id="element-47" data-mp="1etgdmteq4v2b">
          <li className="flex items-start gap-3" data-id="element-48" data-mp="1euri6vfzu6uh">
            <MailIcon className="mt-0.5 h-5 w-5 shrink-0 text-safety" aria-hidden="true" data-id="element-49" data-mp="1jsjctx80w72d" />
            <span data-id="element-50" data-mp="1jq6ydu1h4eu2">
              <span className={`block font-semibold ${heading}`} data-id="element-51" data-mp="3fveiy2l194d1">E-mail</span>
              <a href={site.emailHref} className="break-all hover:text-safety" data-id="element-52" data-mp="3ftbon6cukp2i">
                {site.email}
              </a>
            </span>
          </li>
          <li className="flex items-start gap-3" data-id="element-53" data-mp="3pm95l826y5z0">
            <PrinterIcon className="mt-0.5 h-5 w-5 shrink-0 text-safety" aria-hidden="true" data-id="element-54" data-mp="3kv0ywjs8wypj" />
            <span data-id="element-55" data-mp="2grnrrzohvu8">
              <span className={`block font-semibold ${heading}`} data-id="element-56" data-mp="2g8gr6bkgruz">Fax</span>
              {site.fax}
            </span>
          </li>
          <li className="flex items-start gap-3" data-id="element-57" data-mp="3ujsoil9u36xa">
            <MapPinIcon className="mt-0.5 h-5 w-5 shrink-0 text-safety" aria-hidden="true" data-id="element-58" data-mp="cepd6it9xyof" />
            <span data-id="element-59" data-mp="7fuv5j34se5d">
              <span className={`block font-semibold ${heading}`} data-id="element-60" data-mp="7fctg6xp97q2">
                Mailing Address
              </span>
              {site.address.company}
              <br data-id="element-61" data-mp="2e8evr8tyvurq" />
              {site.address.line1}
              <br data-id="element-62" data-mp="2980uc9mvfj2o" />
              {site.address.city}, {site.address.state} {site.address.zip}
            </span>
          </li>
          <li className="flex items-start gap-3" data-id="element-63" data-mp="opp16u7r37ap">
            <PhoneIcon className="mt-0.5 h-5 w-5 shrink-0 text-safety" aria-hidden="true" data-id="element-64" data-mp="to08oyakp5pr" />
            <span data-id="element-65" data-mp="eznbxz3nviu7">
              <span className={`block font-semibold ${heading}`} data-id="element-66" data-mp="f05ibok1fdfu">Website</span>
              <a href={site.url} className="hover:text-safety" data-id="element-67" data-mp="jy6zu51tf4p7">
                totalhomeimp.com
              </a>
            </span>
          </li>
        </ul>
      </div>
    </div>;
}